<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ title }}</p>
    </header>
    <section class="modal-card-body">
      <div id="content" v-html="content"></div>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cerrar
      </button>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'InfoModal',
  props: ['content', 'title'],
  data: () => ({})
}
</script>
<style lang="less" scoped></style>
